import * as TYPES from './types'

export default {
  [TYPES.MAIN_SET_LANGUAGE] (state, lang) {
    state.language = lang
  },
  [TYPES.MAIN_SET_AUTH_INTENT] (state, intent) {
    state.authIntent = intent
  }
}
